import React, { useState, useEffect } from "react";
import ApiConfig from "../api/ApiConfig";
import { simpleGetCall, PostCallWithErrorResponse, postWithAuthCallWithErrorResponse } from "../api/ApiServices";
import { useNavigate } from "react-router-dom";
import { UseDispatch, useDispatch } from "react-redux";
import { updateData } from "../redux/roundtoSlice";

import { AppContext } from "../contaxt/AppContext";
const AppState = (props) => {

  const [isQuizWeb, setIsQuizWeb] = useState(false)
  const [isNotIntested, setIsNotIntersted] = useState(false)
  const navigate = useNavigate()

  const dispatch = useDispatch()
  const [percentage, setPercentage] = useState(0);
  const [isNormal, setIsNormal] = useState(true);
  console.log(percentage);
  //   const dispach = useDispatch();
  const [tokendatacontaxt, settokendatacontaxt] = useState("");
  const [hide, sethide] = useState(false);
  const [Pecentagedata, setPecentagedata] = useState("");
  const [ishowMessgLogn, setIsShowMsgLgn] = useState(false)
  const [displayMsg, setDisplayMsg] = useState('')
  const [customerData, setCustomerData] = useState({
    api_key: localStorage.getItem("api_key")
      ? localStorage.getItem("api_key")
      : null,

    User_id: localStorage.getItem("User_id")
      ? localStorage.getItem("User_id")
      : null,
  });

  const [isQueryLogin, setIsQueryLogin] = useState(false)

  const [uniqueCode, setUniqueCode] = useState()

  const ENDPOINT = ApiConfig.BASE_URL;
  function useDebounce(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);
    return debouncedValue;
  }

  useEffect(() => {
    if (customerData.customer_id) {
    }
  }, [customerData.customer_id]);



  console.log("customerData", customerData);
  const [ChangeLang, SetChangeLang] = useState("");
  const [PageMsg, SetPageMsg] = useState("");
  const [codequerylgin, setcodequerylgin] = useState(false);
  const [userlgin, setUserlgin] = useState(false);
  const getUserProgress = async (code, id, redircet = false, isEdit = false, isGetStep = false) => {


    let res = await simpleGetCall(ApiConfig.GET_APPLICATION_STATUS + `currentUserId=${id}&code=${code}`)


    if (res?.response?.currentStep == 1 && redircet) {

      navigate(`/LoginWithCode?code=${code}`, { state: { code } });
      return
    }

    if (isEdit) {

      return
    }

    // navigate('/InActiveJobCode')
    // dispatch(updateData({ field: 'type', value: 'ApplicationStarted' }))

    let payload = {
      "code": code,
      "userId": id,
      "stepsCompleted": res?.response?.stepsCompleted
    }

    if (isGetStep) return res

    PostCallWithErrorResponse(ApiConfig.SEND_EMAIL_FOR_GET_APP_PROSS, payload)




  }

  const userStatus = async (id, code) => {


    let res = await simpleGetCall(ApiConfig.GET_IS_INTERSTED + `?userId=${id}&code=${code}`)

    return res

  }

  const handleStep = (step) => {
    if (step == 2) {

      navigate("/JobApplicationProcess?isRedirect=" + true);
      dispatch(updateData({ field: 'isEditDetails', value: true }))
    }
    if (step == 3) {
      navigate("/CompanyName");
    }

    if (step === 4 || step === 5) {
      dispatch(updateData({ field: 'step', value: 2 }))
      navigate("/LywoApplicationStatus");
    }

    if (step === 6) {
      navigate('/LywoApplicationStatus1')
      dispatch(updateData({ field: 'isQuiz', value: true }))
    }

    if (step == 7) {
      dispatch(updateData({ field: 'step', value: 3 }))
      dispatch(updateData({ field: 'isQuiz', value: true }))
      navigate('/LywoApplicationStatus')
    }
  }

  return (
    <div>
      <AppContext.Provider
        value={{
          userlgin,
          setUserlgin,
          PageMsg,
          SetPageMsg,
          codequerylgin,
          setcodequerylgin,
          customerData,
          setCustomerData,
          tokendatacontaxt,
          settokendatacontaxt,
          sethide,
          Pecentagedata,
          setPecentagedata,
          ChangeLang,
          SetChangeLang,
          hide,
          percentage,
          setPercentage,
          isNormal,
          setIsNormal,
          uniqueCode,
          setUniqueCode,
          isQueryLogin,
          setIsQueryLogin,
          isQuizWeb,
          getUserProgress,
          ishowMessgLogn,
          setIsShowMsgLgn,
          displayMsg,
          setDisplayMsg,
          isNotIntested,
          setIsNotIntersted,
          userStatus,
          handleStep
        }}
      >
        {props.children}
      </AppContext.Provider>
    </div>
  );
};

export default AppState;
